/* Menú mobile: acordeón. Reemplaza el drill-down de <mobile-sliderule>. */
(function () {
  // true = solo una categoría abierta a la vez | false = varias a la vez
  var EXCLUSIVO = true;

  function panelDe(item) { return item.querySelector(':scope > .sliderule__panel'); }
  function botonDe(item) { return item.querySelector(':scope > button.sliderow'); }

  function cerrar(item) {
    var p = panelDe(item), b = botonDe(item);
    item.classList.remove('is-open');
    if (p) p.style.setProperty('--acc-h', '0px');
    if (b) b.setAttribute('aria-expanded', 'false');
  }

  function abrir(item) {
    var p = panelDe(item), b = botonDe(item);
    if (!p) return;
    item.classList.add('is-open');
    p.style.setProperty('--acc-h', p.scrollHeight + 'px');
    if (b) b.setAttribute('aria-expanded', 'true');
  }

  function init() {
    document.querySelectorAll('.drawer__menu').forEach(function (nav) {
      if (nav.dataset.acordeon) return;
      nav.dataset.acordeon = 'on';

      nav.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('button.sliderow[data-sliderule-open]');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation(); // corta el handler del tema

        var item = btn.closest('mobile-sliderule');
        var abierto = item.classList.contains('is-open');

        if (EXCLUSIVO) {
          nav.querySelectorAll('mobile-sliderule.is-open').forEach(cerrar);
        } else if (abierto) {
          cerrar(item);
        }
        if (!abierto) abrir(item);
      }, true); // captura
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();